import { Theme } from '@/theme';
import Button from '@CS/components/Button';
import styled, { css } from 'styled-components';
import { ScreenWrapper } from '@CS/app/App.styles';

export const PageContainer = styled(ScreenWrapper)`
  &&& {
    justify-content: start;
    max-height: 100vh;
  }
`;

export const Scene = styled.canvas`
  position: fixed;
  margin: 0;

  left: 0;
  top: 0;
`;

export const PageContent = styled.div`
  box-shadow: 0 -4px 4px 0 rgb(222 13 13 / 0.25);
  background-color: ${Theme.color.white};

  padding: 16px 6px 48px;
  border-radius: 16px;

  position: absolute;
  overflow: hidden;

  margin: 0 auto;
  bottom: 8.62vh;

  width: 87.2%;
  z-index: 2;

  right: 0;
  left: 0;
`;

type MinimizeButtonAttributes = {
  hidden?: boolean;
  up?: boolean;
};

export const MinimizeButton = styled(Button)(
  ({ hidden, up }: MinimizeButtonAttributes) => css`
    position: absolute;
    z-index: 1;

    right: 8px;
    top: 8px;

    ${hidden &&
    css`
      display: none;
    `}

    > svg {
      transition: transform 0.3s;
      transform-origin: center;

      ${up &&
      css`
        transform: rotate(180deg);
      `}
    }
  `
);

/* export const FamilyInfoContainer = styled.div`
  position: relative;
`; */

export const FamilyNameControl = styled.div`
  justify-content: space-between;

  padding-bottom: 2px;
  align-items: center;

  display: flex;
  gap: 8px;

  > svg path {
    fill: ${Theme.color.orange};
  }
`;

type FamilyMembersContainerAttributes = {
  minimized?: boolean;
};

export const FamilyMembersContainer = styled.div(
  ({ minimized }: FamilyMembersContainerAttributes) => css`
    transition: max-height 0.3s ease-in-out, margin-top 0.3s, opacity 0.3s;
    -webkit-overflow-scrolling: touch;
    overscroll-behavior-y: none;

    position: relative;
    padding: 0px 10px;
    max-height: 208px;
    margin-top: 16px;

    overflow: auto;
    display: block;
    height: 208px;

    ${minimized &&
    css`
      margin-top: 0;
      max-height: 0;
      opacity: 0;
    `}
  `
);

export const FamilyNameContainer = styled.div`
  justify-content: center;

  align-items: center;
  margin-bottom: 8px;

  display: flex;
  gap: 8px;
`;

export const FamilyNameTitle = styled.h2`
  font-family: ${Theme.font.family.speedeeCondensed};
  font-size: ${Theme.rems(40)};

  overflow-wrap: anywhere;
  word-break: break-all;

  text-align: center;
  line-height: 90%;
  max-width: 65%;
`;

export const FamilyNameInput = styled.input`
  font-family: ${Theme.font.family.speedeeCondensed};
  font-weight: ${Theme.font.weight.bold};

  font-size: ${Theme.rems(35)};
  color: ${Theme.color.text};
  width: calc(100% - 90px);

  line-height: 90%;
  padding: 0px 5px;

  height: 42px;
  border: none;

  &:active,
  &:focus {
    outline: none;
  }
`;

export const FamilyDescription = styled.span`
  font-size: ${Theme.rems(16)};
  color: ${Theme.color.text};

  text-align: center;
  position: relative;

  line-height: 1.4;
  display: block;
`;

export const ButtonsContainer = styled.div`
  justify-content: space-between;
  bottom: calc(8.62vh - 30px);

  position: absolute;
  display: flex;

  height: 60px;
  width: 87.2%;

  z-index: 2;
  gap: 8px;

  > button {
    padding: 0;

    &:last-child {
      border-color: ${Theme.color.white};
    }
  }
`;
